import { useContext, useCallback } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export const useLocalizeBudget = () => {
  const i18n = useContext(I18nContext);
  const localizeBudget = useCallback((budget, currency) => i18n.formatCurrency(
    Number(budget), currency.toUpperCase(),
    { withSymbol: false, maximumFractionDigits: 2 }
  ), [i18n]);
  return {
    localizeBudget,
  };
};
